<template>
  <section>
    <Header :user="user" />
    <main class="main animated fadeIn faster" :class="{ 'expand-main': false }">
      <div class="contenedor py-0">
        <h4>{{ $t("lang.orders.orders") }} {{ item.toUpperCase() }}</h4>
        <div
          class="d-flex align-items-center justify-content-center w-100"
          v-if="loading"
        >
          <LoadingSpinner></LoadingSpinner>
        </div>
        <div v-else class="mx-2">
          <div v-if="orders.length > 0">
            <div class="col-md-12 w-100 my-2 card p-2">
              <div class="d-flex align-items-center">
                <span class="font-weight-bold">Filter by Oliver Sale: </span>
                <span
                  v-if="userOliverSales.length <= 1"
                  class="loadingres spinner-border loading-spinner ml-2"
                ></span>
                <div v-else class="w-25 px-2">
                  <IndustrySearch
                    :option_list="userOliverSales"
                    :default_values="userOliverSale"
                    :key="key"
                    :multiple="false"
                    @change="init"
                  />
                </div>
              </div>
            </div>
  
            <div class="col-md-12 w-100 my-2 card p-2">
              <div class="mx-0 px-0 table-responsive">
                <div class="row">
                  <Table
                    v-if="orders.length > 0"
                    class="mx-2"
                    :headers="headers"
                    :cols="cols"
                    :data="orders"
                    :checkbox="false"
                    :notselect="true"
                    :model="model"
                    @openTarget="openTarget"
                    @openClient="openClient"
                  ></Table>
                  <!-- 
                    <table class="table table-bordered text-center">
                      <thead>
                        <th>Time</th>
                        <th>{{ $t("lang.label.order") }}</th>
                      </thead>
                      <template v-for="item in orders">
                        <tr :key="item.id">
                          <td>
                            <span
                              class="badge"
                              :class="taskOpenHoursClass(item.task_open_hours)"
                            >
                              {{ item.task_open_hours }} h
                            </span>
                          </td>
                          <td>
                            <router-link
                              target="_blank"
                              class="text-primary"
                              :to="'/orders/' + item.id"
                              @mousedown.native="mousedown('/orders/' + item.id)"
                            >
                              {{ item.name }}
                            </router-link>
                          </td>
                        </tr>
                      </template>
                    </table> -->
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else>      
            <div class="col-12 col-md-10 offset-md-1 text-center " >
              <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
                <h6>
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  No orders to show
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
import { targetsService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import loadingSpinnerBar from "@/components/LoadingSpinnerBar.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Table,
    LoadingSpinner,
    loadingSpinnerBar,
    IndustrySearch,
  },

  data() {
    return {
      item: null,
      loading: true,
      target_id: false,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      orders: [],
      key: 232332,
      oliver_sale: 0,
      userOliverSale: ["0"],
      userOliverSales: [{ id: "0", label: "All" }],
      cols: [
        [
          {
            value: "task_open_hours",
            type: "time",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
          },
        ],
        [
          {
            value_emit: "id",
            value: "target_status_id",
            // class: "text-primary",
            type: "emit",
            emit: "editOrder",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "1",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.orders.status_prepare_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.stopped"),
                badge_tooltip: this.$t("lang.orders.status_inactive_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "3",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.targets.pending"),
                badge_tooltip: this.$t("lang.orders.status_draft_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "41",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.monthlypaused"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
                badge_tooltip: this.$t("lang.orders.status_achived_tooltip"),
              },
            ],
          },
        ],

        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
            badges: [
              {
                badge_if: "client_status_id",
                badge_value: "2",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.onBoarding.onboarding"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },

              {
                badge_if: "client_status_id",
                badge_value: "9",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.label.validating"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "3",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.active"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "5",
                badge_class: "badge badge-info text-white",
                badge_label: this.$t("lang.appointments.standby"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "8",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.pendingdeleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "7",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.payment.Recovery"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "6",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.deleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
      ],
      headers: [
        {
          label: "Time",
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.token.order_name"),
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.column.status"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide",
          id: 11,
        },
      ],
    };
  },

  mounted() {
    this.setHeader();
    this.getOliverSales();
    this.init();
  },

  watch: {
    "$route.params.item"(newVal) {
      if (newVal) {
        this.loading = true;
        //this.getOliverSales();
        this.init(); // Reactualiza si el parámetro cambia
      }
    },
    userOliverSale(newVal) {
      if (newVal) {
        console.log(newVal);
        this.oliver_sale = newVal[0];
        this.loading = true;
        this.init(); // También reactualiza si cambia userOliverSale
      }
    },
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    setHeader(){
      switch (this.$route.params.item) {
        case "missing":
          this.setCurrentRoute({ page: "missing", label: "Campaigns Missing" });
          break;
        case "reported":
          this.setCurrentRoute({ page: "reported", label: "Campaigns Reported" });
          break;
      }
    },

    getOliverSales() {
      usersService
        .getUserOliverSales()
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            console.log(userOliverSalesWithlabel);
            this.userOliverSales.push(...userOliverSalesWithlabel);
            this.userOliverSales.map((it) => {
              if (it.id == this.currentUser.id) {
                this.userOliverSaleId = it.id;
                this.userOliverSale = [it.id.toString()];
              }
            });
            this.key++;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    init() {
      this.item = this.$route.params.item; // Accede al parámetro
      console.log(this.userOliverSale);
      let body = {
        [this.item]: true,
        oliver_sale: this.oliver_sale,
      };
      targetsService.getOrderWarning(body).then((res) => {
        this.orders = res.targets;
        this.loading = false;
      });
      if (this.item == "reported") {
        this.$emit(
          "updateHeader",
          "Reported Campaigns : Campaigns that have remained in En préparation - signalé status for more than 4 days"
        );
      }
      if (this.item == "unverified") {
        this.$emit(
          "updateHeader",
          "Unverified Campaigns that have remained in en préparation - non vérifié status for more than 3 days"
        );
        this.headers.push({
          label: "jour preparation",
          class: "overflowhide",
          id: 12,
        });
        this.cols.push([
          {
            value: "preparation_days",
            type: "time",
          },
        ]);
      }

      // Realiza una solicitud o actualiza el estado del componente según el parámetro
    },
    user() {
      return this.$store.state.authentication.user;
    },

    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 24) {
        return "badge-warning";
      } else if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
    openTarget(target_id) {
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  },
};
</script>
